// extracted by mini-css-extract-plugin
export var centerText = "_gu-8";
export var container = "_gu-0";
export var doughnutContainer = "_gu-7";
export var legend = "_gu-a";
export var legendItemColorDisplay = "_gu-b";
export var legendItemLabel = "_gu-d";
export var legendItemValue = "_gu-c";
export var lg = "_gu-5";
export var maxWidth = "_gu-9";
export var md = "_gu-4";
export var responsive = "_gu-6";
export var sm = "_gu-3";
export var xs = "_gu-2";
export var xxs = "_gu-1";